import { render, staticRenderFns } from "./advantageIntroduce.vue?vue&type=template&id=539b5cc0&scoped=true&"
import script from "./advantageIntroduce.vue?vue&type=script&lang=js&"
export * from "./advantageIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./advantageIntroduce.vue?vue&type=style&index=0&id=539b5cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b5cc0",
  null
  
)

export default component.exports